import { gql } from '__generated__';

const GetLocalizationOptions = gql(`
  query GetLocalizationOptions {
    timezones {
      name
      title
    }
  }
`);

export default GetLocalizationOptions;
